import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import IntroStage from "./IntroStage.jsx";
import PinballTable from "./PinballTable.jsx";
import DebriefStage from "./DebriefStage.jsx";
import { BALLS_PER_GAME } from "./data.js";
import "./CashCascade.css";

export default function CashCascade() {
  const navigate = useNavigate();
  const [stage, setStage] = useState("intro");
  const [totalScore, setTotalScore] = useState(0);
  const [ballsRemaining, setBallsRemaining] = useState(BALLS_PER_GAME);
  const [jackpots, setJackpots] = useState(0);

  const restart = () => {
    setTotalScore(0);
    setBallsRemaining(BALLS_PER_GAME);
    setJackpots(0);
    setStage("intro");
  };

  const handleScoreDelta = (points) => {
    setTotalScore((s) => s + points);
  };

  const handleJackpot = () => {
    setJackpots((j) => j + 1);
  };

  const handleBallLost = () => {
    setBallsRemaining((n) => Math.max(0, n - 1));
  };

  const handleGameOver = () => {
    setStage("debrief");
  };

  return (
    <div className="mx-auto max-w-md px-4 py-8">
      <button onClick={() => navigate("/")} className="btn-ghost mb-6 !text-[8px]">
        ◀ BACK TO LEVELS
      </button>

      <div className="panel relative overflow-hidden p-6">
        <div className="mb-6">
          <p className="label-pixel text-gold">Level 15</p>
          <h1 className="pixel-heading text-base text-mist sm:text-xl">Cash Cascade</h1>
        </div>

        {stage === "playing" && (
          <div className="mb-4 flex justify-between font-display text-[9px] text-mist">
            <span>SCORE: <span className="text-gold">{totalScore.toLocaleString()}</span></span>
            <span>BALL: <span className="text-cyan">{BALLS_PER_GAME - ballsRemaining + 1}</span>/{BALLS_PER_GAME}</span>
          </div>
        )}

        {stage === "intro" && <IntroStage onStart={() => setStage("playing")} />}

        {stage === "playing" && (
          <PinballTable
            onScoreDelta={handleScoreDelta}
            onBallLost={handleBallLost}
            onJackpot={handleJackpot}
            onGameOver={handleGameOver}
          />
        )}

        {stage === "debrief" && (
          <DebriefStage totalScore={totalScore} jackpots={jackpots} onRetry={restart} />
        )}
      </div>
    </div>
  );
}
